import { Link } from "react-router-dom";
import { ArrowRight, MapPin } from "lucide-react";
import { SITE, DIRECTIONS_URL, GATHERINGS } from "../../content/site";
import { MaskLines, Reveal } from "../motion";
import { Eyebrow } from "../Brand";
import { Cta } from "../Cta";

export function Gathering() {
  const [, wed, sat] = GATHERINGS;
  return (
    <section className="grain relative overflow-hidden bg-[#090909] py-24 lg:py-36" aria-labelledby="gather-title" data-testid="home-gathering">
      <div className="relative mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <Eyebrow>The Gathering</Eyebrow>
            <MaskLines
              lines={["We gather", "with", { text: "intentionality.", className: "text-[#B8324E]" }]}
              className="mt-6 font-display text-[13vw] font-bold uppercase leading-[0.88] tracking-tight text-[#F6F2F0] sm:text-7xl lg:text-8xl"
              testId="gathering-headline"
            />
          </div>
          <Reveal className="flex items-end lg:col-span-5">
            <p id="gather-title" className="text-base leading-relaxed text-[#B9AFB2] sm:text-lg">
              We come together to worship Jesus Christ, open the Scriptures, grow in truth, and strengthen one another for faithful Christian living. Our gathering is not the end of our mission—it equips us to live out the gospel beyond the four walls.
            </p>
          </Reveal>
        </div>

        <div className="mt-16 grid gap-px bg-[#F6F2F0]/10 lg:mt-24 lg:grid-cols-12 lg:grid-rows-2">
          <Reveal className="flex flex-col justify-between gap-10 bg-[#171416] p-7 sm:p-10 lg:col-span-7 lg:row-span-2" data-testid="gathering-sunday">
            <div className="flex items-start justify-between">
              <p className="eyebrow">Every Sunday</p>
              <span className="font-display text-xs tracking-[0.3em] text-[#B9AFB2]">IN PERSON</span>
            </div>
            <div>
              <p className="font-display text-[22vw] font-bold leading-[0.8] tracking-tight text-[#F6F2F0] sm:text-[9rem] lg:text-[10rem]" data-testid="gathering-sunday-time">
                2:30<span className="text-[#B8324E]">PM</span>
              </p>
              <p className="mt-6 flex items-start gap-3 text-lg text-[#F6F2F0]" data-testid="gathering-address">
                <MapPin className="mt-1 h-5 w-5 shrink-0 text-[#B8324E]" aria-hidden="true" />
                <span>{SITE.address.street}<br />{SITE.address.city}, {SITE.address.region} {SITE.address.zip}</span>
              </p>
            </div>
            <div className="flex flex-col gap-3 sm:flex-row">
              <Cta href={DIRECTIONS_URL} testId="gathering-directions-button">Get Directions</Cta>
              <Cta to="/visit" variant="ghost" testId="gathering-plan-visit-button">Plan Your Visit</Cta>
            </div>
          </Reveal>
          {[wed, sat].map((g) => (
            <Link key={g.id} to={`/ministries#${g.id}`} className="group flex flex-col justify-between gap-8 bg-[#090909] p-7 transition-colors duration-500 hover:bg-[#171416] sm:p-10 lg:col-span-5" data-testid={`gathering-${g.id}-link`}>
              <div className="flex items-center justify-between">
                <p className="font-display text-sm uppercase tracking-[0.3em] text-[#B9AFB2]">{g.day}</p>
                <ArrowRight className="h-5 w-5 text-[#B8324E] transition-transform duration-300 group-hover:translate-x-1" aria-hidden="true" />
              </div>
              <div>
                <h3 className="font-display text-3xl font-semibold uppercase tracking-tight text-[#F6F2F0] sm:text-4xl">{g.name}</h3>
                <p className="mt-3 text-sm text-[#B9AFB2]">{g.where}{g.id === "wednesday" ? ` · ${g.time}` : ""}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
